import { RouterLink } from '@redux-first-router-link';
import DocumentHeader from '@/components/DocumentHeader';
import { Button } from '@simplywallst/ui-core';
import { Heading } from '@simplywallst/ui-core/next';
import { ROUTE_PORTFOLIO_DEMO } from '@/constants/routes';
import { useFlag } from '@/features/unleash';
import { usePortfolios } from '@/hooks/portfolio/usePortfolio';
import { NewLegacyPortfolio } from './components/NewLegacyPortfolio';
import { NewManualPortfolio } from './components/NewManualPortfolio';
import { NewLinkedPortfolio } from './components/NewLinkedPortfolio';

// TODO: When 'mono-portfolio-new-page' flag is deprecated, move this into `NewPortfolio.tsx`
export const NewPortfolioPage = () => {
  const { data, isLoading } = usePortfolios();

  const linkingFlag = useFlag({ name: 'mono-portfolio-linking' });
  if (!linkingFlag.flagsReady) return;

  return (
    <>
      <DocumentHeader title="New Portfolio" />
      <section className="w-full sm:px-[2.4rem] sm:py-x4 max-w-screen-xl grid sm:gap-x4 text-solid @container/newPortfolio">
        <div className="flex flex-wrap justify-between items-center gap-x-x4 gap-y-x2 px-x2 py-x4 sm:p-0">
          <div className="grid gap-x1">
            <Heading size="xLarge">
              {(isLoading && '') ||
                (data?.length && 'Create a new portfolio') ||
                'Create your first portfolio'}
            </Heading>
            {/* <div className="text-softer text-xs max-w-[55ch]">
              Free forever for up to 10 holdings.
            </div> */}
          </div>
          <div className="flex flex-wrap gap-x-x1 gap-y-x1_5">
            <Button
              to={{ type: ROUTE_PORTFOLIO_DEMO }}
              as={RouterLink}
              styleType="loud"
              className="w-fit whitespace-nowrap focus-visible:ring-2 focus-visible:duration-0 focus-visible:ring-accent ![font-size:theme(fontSize.xs)]"
            >
              <span className="pr-x0_25 scale-105 inline-block">🍿</span> View
              demo portfolio
            </Button>
          </div>
        </div>
        <div className="grid gap-x2 sm:gap-x3 @7xl/newPortfolio:grid-cols-[61.8%_auto]">
          {linkingFlag.enabled && (
            <section className="flex flex-col gap-x2 sm:gap-x3 bg-surface-1 sm:rounded-lg py-x3 @3xl/newPortfolio:col-span-2 @7xl/newPortfolio:col-span-1 @7xl/newPortfolio:row-span-2">
              <NewLinkedPortfolio />
            </section>
          )}
          <section className="bg-surface-1 sm:rounded-lg px-x2 py-x3 sm:p-x3">
            <NewManualPortfolio />
          </section>
          <section className="bg-surface-1 sm:rounded-lg px-x2 py-x3 sm:p-x3">
            <NewLegacyPortfolio />
          </section>
        </div>
      </section>
    </>
  );
};
